<template>
  <div class="page">
    <p class="p1">积分明细</p>
    <ul class="ul_1"  v-for="(item,index) in integralList" :key="index">
      <li>
        <p class="p_c">
          <span>{{item.remark}}</span>
          <span :class="item.integral < 0 ? 'shutdown' : 'shutdown1'">
            {{item.integral}}
          </span>
        </p>
        <p class="p2_c">
          <span>{{item.payTime}}</span>
          <span>{{item.accountIntegral}}</span>
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
import { wx_integral } from "@/api/api.js"; //获取该卡的积分
export default {
  data() {
    return {
      integralList:[],
    };
  },
  computed: {},
  methods: {
    initData() {
      let params= {
        iccid:this.$route.query.iccid,
      }
      wx_integral(params).then(res=>{
        if(res.data.code == 200){
          this.integralList = res.data.data;
          this.integralList.map(item=>{
            item.payTime = item.payTime.substr(0,16);
            if(item.payType == 1){
              item.integral =  "+" + item.integral;
            }else{
              item.integral = -item.integral;
            }
          })
          this.integralList.sort(function(a, b) {
             return b.payTime< a.payTime? -1 : 1
          })
        }
      })
    },
  },
  created() {
    this.initData()
  },
  mounted() {
    window.document.title = "个人中心";
  },
};
</script>
<style scoped lang="less">
  .page{
    .p1{
      text-align: center;
      height: 40px;
      line-height: 40px;
      // background: linear-gradient(#FFCC99,#FF9966,#FD986E);
      background: #F94040;
      color: #fff;
      font-size: 16px;
    }
    .ul_1{
      padding: 0px 10px;
      box-sizing: border-box;
      li{
        height: 60px;
        line-height: 30px;
        border-bottom:1px solid #F0F0F0;
        p{
          display: flex;
          justify-content: space-between;
          padding: 0px 10px;
        }
        .p_c{
          color: #151515;
          font-weight: bold;
          font-size: 16px;
        }
        .shutdown{
          color: red;
          font-size: 20px;
        }
       .shutdown1{
          color:#88DCA1;
          font-size: 20px;
        }
        .p2_c{
          // color: #999;
          font-size: 14px;
        }
      }
    }
  }

</style>

